import React, { createContext, useState, useContext, useEffect } from 'react'
import deLocale from '../locales/de.json'

const LocaleContext = createContext()

export const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState('de')
  const [translations, setTranslations] = useState(deLocale)

  useEffect(() => {
    // Load locale based on preference
    const savedLocale = localStorage.getItem('locale') || 'de'
    setLocale(savedLocale)
    loadTranslations(savedLocale)
  }, [])

  const loadTranslations = async (localeCode) => {
    try {
      const translations = await import(`../locales/${localeCode}.json`)
      setTranslations(translations.default)
      localStorage.setItem('locale', localeCode)
    } catch (error) {
      console.error(`Failed to load locale ${localeCode}:`, error)
      // Fallback to German
      setTranslations(deLocale)
    }
  }

  const changeLocale = (localeCode) => {
    setLocale(localeCode)
    loadTranslations(localeCode)
  }

  const t = (key, params = {}) => {
    const keys = key.split('.')
    let value = translations
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k]
      } else {
        return key
      }
    }

    if (typeof value !== 'string') {
      return key
    }

    // Simple parameter replacement
    return value.replace(/\{\{(\w+)\}\}/g, (match, paramKey) => {
      return params[paramKey] !== undefined ? params[paramKey] : match
    })
  }

  return (
    <LocaleContext.Provider value={{ locale, changeLocale, t, translations }}>
      {children}
    </LocaleContext.Provider>
  )
}

export const useLocale = () => {
  const context = useContext(LocaleContext)
  if (!context) {
    throw new Error('useLocale must be used within LocaleProvider')
  }
  return context
}
